import { OperatingExpense } from 'views/ProFormaTable/types';
import { NSCheckbox } from 'bricks';
import NSProFormaInput from 'bricks/NSProFormaInput/NSProFormaInput';
import { RecoverableExpense } from './types';

type Props = {
    expense: OperatingExpense;
    recoverableExpense: RecoverableExpense;
    updateRecoverableExpenseRow: (id: number, data: Partial<RecoverableExpense>) => void;
};

const clampPercent = (n: number) => Math.max(0, Math.min(100, n));

const RecoverableExpenseItem = ({ expense, recoverableExpense, updateRecoverableExpenseRow: updateRow }: Props) => {
    const displayPercentage = Math.round((recoverableExpense.recoverablePercentage ?? 0) * 100);

    return (
        <div className="d-flex justify-content-between align-items-center pb-2">
            <NSCheckbox
                id={`rec-${expense.id}`}
                checked={recoverableExpense.isRecoverable}
                callback={checked => updateRow(expense.id, { isRecoverable: checked })}
                labelText={expense.name}
            />
            <div className='w-25'>
                <NSProFormaInput
                    name={`rec-pct-${expense.id}`}
                    type="number"
                    value={displayPercentage}
                    handleUpdateValue={value => {
                        const clamped = clampPercent(Number(value) || 0);                                     
                        const patch: Partial<RecoverableExpense> = { recoverablePercentage: clamped / 100 };
                        if (clamped > 0 && !recoverableExpense.isRecoverable) {
                            patch.isRecoverable = true;
                        } else if (clamped === 0 && recoverableExpense.isRecoverable) {
                            patch.isRecoverable = false;
                        }
                        updateRow(expense.id, patch);  
                    }}
                    appendInputAddon={<div className="px-2">%</div>}
                    inputGroupClassName="p-0"
                    min={0}
                    max={100}
                    step={1}
                />
            </div>
        </div>
    );
};

export default RecoverableExpenseItem;
